import type { FaireProductEntity } from "../../entity_types/product";

export const p_9vnqqwspwq: FaireProductEntity = {
  token: "p_9vnqqwspwq",
  type: "product",
  name: 'Marble Turtle Zodiac Mixed Symbol & Animal 1.5"',
  brandToken: "b_4e6hayu5vx",
  brandName: "SS handcrafted Art",
  imageUrl:
    "https://cdn.faire.com/fastly/3e0b6091a8f0eaffe31ca8bfa7790d307430b192f1248be30e78fc885e754fa5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e13c9d09182dc870cf41e9a0b660d1b5c3bcdaf9f3962b958927bb0d0f569b36.jpeg",
    "https://cdn.faire.com/fastly/a01eea87f209cab14bb651ed397fb38ccc21ec5da3d8ccdb1827958f354c6563.jpeg",
  ],
  priceDollars: 3.12,
  description:
    "Color variations are expected\n\nSizes are approximate\n\nHandcrafted out of natural marble, in Ecuador\n\nWith every purchase, a portion goes to The Turtleman Foundation to help save one sea turtle at a time",
  tags: [],
  msrpDollars: 6.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:35.495Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
